'use client'
import { useState } from 'react'

import { Button } from '@/components/Layout/aichat/Button'
import ProjectCard from '@/components/Layout/startups/project-card'
import FilterSearchBar from '@/components/ui/shared/filter-search-bar'
import { businessSectors } from '@/lib/utils/constants'
import { useAuth } from '@/lib/utils/providers/supabase/supabase-auth-provider'
import Link from 'next/link'
import { BsX } from 'react-icons/bs'
import ApplicationHeader from './GridHeader'
import styles from './index.module.css'

const sortOptions = [
  { name: 'Most recent list' },
  { name: 'Raised Amount' },
  { name: 'Raised Percentage' },
]

export default function SearchPage({ projectsData, isSearchPage = true }) {
  const { user } = useAuth()
  const [selectedSort, setSelectedSort] = useState('')
  const [filterItems, setFilterItems] = useState({})
  const [projects, setprojects] = useState(projectsData)
  const [searchVal, setsearchVal] = useState('')
  const [showLoadMore, setShowLoadMore] = useState(false)
  const [showBanner, setShowBanner] = useState(true)
  const [projectsBackup, setProjectsBackup] = useState(projectsData)
  const [filterOptions, setFilterOptions] = useState({
    'Tax relief': ['SEIS', 'EIS'],
    Sectors: [...businessSectors],
    'Business stage': [
      'Concept',
      'POC',
      'Demo',
      'MVP',
      'Revenue Making',
      'Product',
    ],
    Country: ['United States', 'United Kingdom'], //['United States', 'United Kingdom'],
  })

  const filterItemsCount = Object.values(filterItems).flat().length

  function toggleFilterItem(key, value) {
    const items = { ...filterItems }
    let array = [...(filterItems[key] || [])]

    if (array.includes(value)) array = array.filter((item) => item !== value)
    else array.push(value)

    items[key] = array
    setFilterItems(items)
  }

  const handleSearch = (e) => {
    e.preventDefault()
    queryData()
  }
  function clearAll() {
    setFilterItems({})
    setprojects(projectsBackup)
    setsearchVal('')
  }

  const queryData = (data) => {
    let lProjectArr = data || projectsBackup
    if (searchVal && searchVal !== '') {
      lProjectArr = lProjectArr.filter((e) => {
        return (
          e?.company_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
          e?.short_description?.toLowerCase().includes(searchVal.toLowerCase())
        )
      })
    }

    //country
    if (filterItems['Country'] && filterItems['Country'].length > 0) {
      lProjectArr = lProjectArr.filter((e) => {
        return filterItems['Country'].includes(e?.company_country)
      })
    }

    //stage
    if (
      filterItems['Business stage'] &&
      filterItems['Business stage'].length > 0
    ) {
      lProjectArr = lProjectArr.filter((e) => {
        return filterItems['Business stage'].includes(e?.stage)
      })
    }

    //tax
    if (filterItems['Tax relief'] && filterItems['Tax relief'].length > 0) {
      if (filterItems['Tax relief'].includes('SEIS')) {
        lProjectArr = lProjectArr.filter((e) => e?.tax_schema?.includes('SEIS'))
      }
      if (filterItems['Tax relief'].includes('EIS')) {
        lProjectArr = lProjectArr.filter((e) => e?.tax_schema?.includes('EIS'))
      }
    }

    //sector
    if (filterItems['Sectors'] && filterItems['Sectors'].length > 0) {
      lProjectArr = lProjectArr.filter((e) => {
        const s = e?.sectors
        const r = s?.constructor !== Array ? s : s.length > 0 ? s[0] : null
        return filterItems['Sectors'].includes(r)
      })
    }
    setprojects(lProjectArr)
  }

  const sortBy = (sortBy) => {
    setSelectedSort(sortBy)
    let sorted
    switch (sortBy.name) {
      case 'Raised Amount':
        sorted = projects?.sort((a, b) => b?.money_raised - a?.money_raised)

        break
      case 'Raised Percentage':
        sorted = projects?.sort(
          (a, b) => b?.raisedPercentage - a?.raisedPercentage,
        )
        break
      case 'Most recent list':
        sorted = projects?.sort(
          (a, b) => new Date(b?.created_at) - new Date(a?.created_at),
        )
        break

      default:
        sorted = projects?.sort(
          (a, b) => new Date(b?.created_at) - new Date(a?.created_at),
        )
    }

    setprojects(sorted)
  }
  return (
    <div className="flex flex-col gap-16 max-w-7xl items-center justify-center mx-auto my-10 w-full overflow-auto">
      <div className="w-full flex flex-col">
        {!user && isSearchPage ? (
          <div className={`mb-8 ${showBanner ? '' : 'hidden'}`}>
            <div
              className={`${styles.container} w-[auto] xl:w-[95%] flex-col sm:flex-row gap-4 sm:mx-auto mx-[20px] relative px-4 lg:px-4 m-auto`}
            >
              <div className="flex items-center gap-4">
                <div className="min-w-[40px] min-h-[40px] bg-white rounded flex items-center justify-center ">
                  <img src={'./chatbot.png'} className="w-[28px]" />
                </div>

                <h1 className="text-base font-[500] text-white">
                  Sign In & Explore: Get AI-Curated Startups Aligned with Your
                  Interests
                </h1>
              </div>
              <div className="flex items-center gap-4 min-w-[fit-content]">
                <Link
                  href="/login"
                  className="cursor-pointer min-w-[fit-content] h-[38px] py-[9px] px-[17px] bg-white text-[#18181B] rounded flex items-center justify-center "
                >
                  Get Started
                </Link>
                <div
                  onClick={() => setShowBanner(false)}
                  className=" font-[500] text-white cursor-pointer"
                >
                  <BsX className="w-[24px] h-[24px] " />
                </div>
              </div>
            </div>
          </div>
        ) : (
          isSearchPage && (
            <div className={`mb-8 ${showBanner ? '' : 'hidden'}`}>
              <div
                className={`${styles.container} w-[auto] sm:w-[95%] flex-col sm:flex-row gap-4 sm:mx-auto mx-[20px] relative px-4 lg:px-4 m-auto`}
              >
                <div className="flex items-center gap-4">
                  <div className="min-w-[40px] min-h-[40px] bg-white rounded flex items-center justify-center ">
                    <img src={'./chatbot.png'} className="w-[28px]" />
                  </div>

                  <h1 className="text-base font-[500] text-white">
                    Enhance your investment journey — Add more details here to
                    tailor your matches
                  </h1>
                </div>
                <div
                  href="/i/profile"
                  className="flex items-center gap-4 min-w-[fit-content]"
                >
                  <Link
                    href="/i/profile"
                    className="cursor-pointer h-[38px] py-[9px] px-[17px] min-w-[fit-content] bg-white text-[#18181B] rounded flex items-center justify-center "
                  >
                    Get Started
                  </Link>
                  <div
                    onClick={() => setShowBanner(false)}
                    className=" font-[500] text-white cursor-pointer"
                  >
                    <BsX className="w-[24px] h-[24px] " />
                  </div>
                </div>
              </div>
            </div>
          )
        )}

        {isSearchPage ? (
          <div className="relative px-4 lg:px-8 m-auto mb-8 items-center pb-8 mx-auto w-full">
            <div className="flex flex-col justify-between w-full mb-5 md:flex-row ">
              <FilterSearchBar
                searchVal={searchVal}
                setsearchVal={setsearchVal}
                filterItems={filterItems}
                filterItemsCount={filterItemsCount}
                filterOptions={filterOptions}
                toggleFilterItem={toggleFilterItem}
                handleSearch={handleSearch}
                clearAll={clearAll}
                queryData={queryData}
                className={'justify-end'}
              />
            </div>
            <div
              className={` ${
                projects?.length === 0 ? 'h-[840px]' : ''
              } text-white text-[20px] font-[500] leading-[20px] `}
            >
              {projects?.length || 0} Results
            </div>
          </div>
        ) : (
          <ApplicationHeader />
        )}
        <div className="relative px-4 lg:px-8 m-auto ">
          <div className="grid grid-cols-1 gap-12 xl:gap-16 md:grid-cols-2 lg:grid-cols-3">
            {projects &&
              projects?.length > 0 &&
              projects?.map((data, i) => (
                <ProjectCard
                  key={i * Math.random()}
                  className={'lg:max-w-[389px]'}
                  {...{
                    id: data?.id,
                    bannerLogo: data?.logo,
                    logo_url: data?.logo_url || null,
                    businessName: data?.company_name,
                    raiseLimit: data?.money_raised,
                    raiseCurrent: data?.money_target,
                    bio: data?.short_description,
                    businessSector: data?.sectors,
                    company_location: data?.company_location,
                    companyBasedCountry: data?.company_country,
                    hasEIS: data?.tax_schema?.includes('EIS'),
                    hasSEIS: data?.tax_schema?.includes('SEIS'),
                    // isModalPreview: true,
                  }}
                />
              ))}
          </div>
          {showLoadMore && (
            <div className="flex justify-center mt-5">
              <Button
                variant="outlined-green"
                onClick={() => {
                  loadMore()
                }}
              >
                Load More
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
